export default __webpack_public_path__ + "static/media/Group 2116.7b99f042.png";